const baseurl = process.env.REACT_APP_BASEURL;

export const loginapi = baseurl + '/userapp/login/';
export const dashboard = baseurl + '/patientapp/dashboard/';
export const patientList = baseurl + '/patientapp/v1/';
export const createPatientRecordApi = baseurl + '/patientapp/v1/';
export const fetchSpecificPatientData = baseurl + '/patientapp/v1/';
export const updatePatientApi = baseurl + '/patientapp/v1/';
export const patientsPrescription = baseurl + '/patientapp/v2/';
export const fetchPatientsRecords = baseurl + '/patientapp/v3/';
export const recordAdd = baseurl + '/patientapp/v3/';
export const p_reports = baseurl + '/patientapp/v4/';
export const PatientsAppointment = baseurl + '/patientapp/v6/';
export const p_billing = baseurl + '/patientapp/v5/';
export const p_bills = baseurl + '/patientapp/bill_under_patient/';
export const p_billArchive = baseurl + '/patientapp/archive/';
export const checkCoupleId = baseurl + '/patientapp/couplefinder/';
export const createCoupleData = baseurl + '/patientapp/couple_create/';
export const doctors_list = baseurl + '/userapp/doctor_list/';
export const usersListApi = baseurl + '/userapp/v1';
export const userCreateApi = baseurl + '/userapp/v1/';
// export const reportDetailsApi = baseurl + "/patientapp/dailyreport/"
export const reportDetailsApi = baseurl + '/patientapp/v8/';
export const drugInventoryApi = baseurl + '/inventoryapp/d1/';
export const drugCategoryApi = baseurl + '/inventoryapp/d2/';
export const drugVendorApi = baseurl + '/inventoryapp/d3/';

// export const inPatientProcedureApi = nodeBaseUrl + "/api/procedures"
// export const inPatientHospitalApi = nodeBaseUrl + "/api/hospitalDetails"
// export const inPatientSchedultApi = nodeBaseUrl + "/api/inpatientschedule"

export const inPatientProcedureApi = baseurl + '/inpatientapp/procedure/';
export const inPatientHospitalApi = baseurl + '/inpatientapp/hospital/';
export const inPatientSchedultApi = baseurl + '/inpatientapp/inpatient/';

export const fertilityApi = baseurl + '/fertilityapp/fertility-cycle/';
export const fertilityApiStatistics = baseurl + '/fertilityapp/fertility-cycle-statistics/';
export const mainUrl = baseurl;
